import dayjs from "dayjs";
import * as actionTypes from "./actionTypes";

const months = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

const initialState = {
  status: null,
  selectedMonth: `${dayjs(new Date()).format("YYYY-MM")}-01`,
  currMonth: `${dayjs(new Date()).format("YYYY-MM")}-01`,
  currentMonth: `${
    months[parseInt(dayjs().format("YYYY-MM-DD").substring(5, 7), 10)]
  }, ${parseInt(dayjs().format("YYYY-MM-DD").substring(0, 4), 10)}`,
  activeIndex: 0,
  commissions: {
    totalCommission: 0,
    bonus: 0,
    processed: 0,
    processing: 0,
  },
  sales: {
    deliveredSales: 0,
    pendingSales: 0,
    totalSales: 0,
  },

  last8MonthsOverview: [],
  customerDetails: [],
  productDetails: [],
  itemDetails: [],
  isLoading: false,
};

export const actions = {
  updateCustomerDetails: (payload) => ({
    type: actionTypes.UPDATE_CUSTOMER_DETAILS,
    payload,
  }),
  updateProductDetails: (payload) => ({
    type: actionTypes.UPDATE_PRODUCT_DETAILS,
    payload,
  }),
  updateItemDetails: (payload) => ({
    type: actionTypes.UPDATE_ITEM_DETAILS,
    payload,
  }),
  updateSales: (payload) => ({
    type: actionTypes.UPDATE_SALES,
    payload,
  }),
  updateCommission: (payload) => ({
    type: actionTypes.UPDATE_COMMISSION,
    payload,
  }),

  updateSelectedMonth: (payload) => ({
    type: actionTypes.UPDATE_SELECTED_MONTH,
    payload,
  }),
  updateCurrentMonth: (payload) => ({
    type: actionTypes.UPDATE_CURRENT_MONTH,
    payload,
  }),
  setLastMonthOverview: (payload) => ({
    type: actionTypes.SET_LAST_MONTH_OVERVIEW,
    payload,
  }),
  updateActiveIndex: (payload) => ({
    type: actionTypes.ACTIVE_INDEX,
    payload,
  }),
  updateRef1: (payload) => ({
    type: actionTypes.UPDATE_REF1,
    payload,
  }),
  updateRef2: (payload) => ({
    type: actionTypes.UPDATE_REF2,
    payload,
  }),
  updateRef3: (payload) => ({
    type: actionTypes.UPDATE_REF3,
    payload,
  }),
};

const shopPerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CUSTOMER_DETAILS: {
      return {
        ...state,
        customerDetails: action.payload.data,
      };
    }

    case actionTypes.UPDATE_PRODUCT_DETAILS: {
      return {
        ...state,
        productDetails: action.payload.data,
      };
    }

    case actionTypes.UPDATE_ITEM_DETAILS: {
      return {
        ...state,
        itemDetails: action.payload.data,
      };
    }

    case actionTypes.UPDATE_SALES: {
      return {
        ...state,
        sales: action.payload.data,
      };
    }
    case actionTypes.UPDATE_COMMISSION: {
      return {
        ...state,
        commissions: action.payload.data,
      };
    }

    case actionTypes.UPDATE_SELECTED_MONTH: {
      return {
        ...state,
        selectedMonth: action.payload.data,
      };
    }
    case actionTypes.UPDATE_CURRENT_MONTH: {
      return {
        ...state,
        currentMonth: action.payload.data,
      };
    }
    case actionTypes.SET_LAST_MONTH_OVERVIEW: {
      return {
        ...state,
        last8MonthsOverview: action.payload.data,
      };
    }
    case actionTypes.ACTIVE_INDEX: {
      return {
        ...state,
        activeIndex: action.payload.data,
      };
    }
    case actionTypes.UPDATE_REF1: {
      return {
        ...state,
        ref1: action.payload,
      };
    }
    case actionTypes.UPDATE_REF2: {
      return {
        ...state,
        ref2: action.payload,
      };
    }
    case actionTypes.UPDATE_REF3: {
      return {
        ...state,
        ref3: action.payload,
      };
    }
  }
  return state;
};
shopPerformanceReducer.initialState = initialState;

export default shopPerformanceReducer;
